import { render, staticRenderFns } from "./add-template.vue?vue&type=template&id=dfd40602&scoped=true&"
import script from "./add-template.vue?vue&type=script&lang=js&"
export * from "./add-template.vue?vue&type=script&lang=js&"
import style0 from "./add-template.vue?vue&type=style&index=0&id=dfd40602&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd40602",
  null
  
)

export default component.exports